// import React from 'react'
import Html from '../assets/icons8-css3-96.svg'
import Css from '../assets/icons8-html-5-96.svg'
import Tailwind from '../assets/tailwind-css.svg'
import JavaScript from '../assets/icons8-javascript-96.svg'
import Reactjs from '../assets/icons8-react-80.svg'
import Git from '../assets/icons8-git-96.svg'
import Firebase from '../assets/firebase-icon.svg'
import Sass from '../assets/sass-lang-icon.svg'
import Nodejs_Express from '../assets/nodejs_express.jpg'
import Angularjs from '../assets/angularjs.jpg'
import SQL from '../assets/sql.png'
import MongoDb from '../assets/mongodb-logo.svg'

export const Skills = () => {
    return (
        <section>
            {/* tech stack Section */}
            <div className="bg-[#021227] px-8 sm:px-16 py-16 max-w-screen-xl mx-auto" id="skills">
                <div className="">
                    <div className="flex justify-center items-center gap-12 pb-12">
                        <div className="h-px flex-1 bg-[#309543] hidden sm:block"></div>
                        <h2 className="text-4xl font-bold">Tech Stack</h2>
                        <div className="h-px flex-1 bg-[#309543] hidden sm:block"></div>
                    </div>

                    {/* skills */}
                    <div className="grid grid-cols-3  sm:grid-cols-5 gap-12" style={{ fontFamily: "'Roboto Mono', monospace;" }}>

                        {/* Skill 01 */}
                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Html} alt="html icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc]">HTML</p>
                        </div>


                        {/* Skill 02 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Css} alt="css icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc]">CSS</p>
                        </div>

                        {/* Skill 03 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Tailwind} alt="tailwind css icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc] text-center">Tailwind CSS</p>
                        </div>


                        {/* Skill 04 */}
                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Sass} alt="Sass icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc]">Sass</p>
                        </div>
                        {/* Skill 05 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={JavaScript} alt="javascript icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc]">JavaScript</p>
                        </div>


                        {/* Skill 06 */}
                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Reactjs} alt="React icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc]">React</p>
                        </div>


                        {/* Skill 07 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Git} alt="git icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc]">Git</p>
                        </div>
                        {/* Skill 08 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Firebase} alt="Firebase icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc]">Firebase</p>
                        </div>
                        {/* Skill 09 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Nodejs_Express} alt="Firebase icon" className="w-24" />
                            <p className="font-semibold text-[#cccccc]">NodeJs & Express</p>
                        </div>
                        {/* Skill 10 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={Angularjs} alt="Firebase icon" className="w-24" />
                            <p className="font-semibold text-[#cccccc]">AngularJs</p>
                        </div>
                        {/* Skill 11 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={SQL} alt="Firebase icon" className="w-24" />
                            <p className="font-semibold text-[#cccccc]">SQL</p>
                        </div>
                        {/* Skill 12 */}

                        <div className="flex flex-col items-center gap-2 shadow-lg shadow-[#040c16] hover:scale-110 duration-500">
                            <img src={MongoDb} alt="Firebase icon" className="w-24 h-24" />
                            <p className="font-semibold text-[#cccccc]">MongoDB</p>
                        </div>

                    </div>
                </div>
            </div>


        </section>
    )
}
